export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"
export const ApiResponseSuccess = 1
export const APiResponseError = 0
export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500
export const AxiosNetworkError = "ERR_NETWORK"
export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"
export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"
export const FormTypeView = "View"
export const PageTypeGetPaged = "GetPaged"
export const PageTypeCount = "Count"
export const PageSize = 25
export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"
export const GuidDefault = "00000000-0000-0000-0000-000000000000"
export const DateNullDefault = "0001-01-01T00:00:00"
export const Active = "Active"
export const Deleted = "Deleted"
export const StatusCodeActive = "1"
export const StatusCodeDelete = "2"
export const DepositReceived = "Received"
export const NoDeposit = "No Deposit"
export const MdrOnUs = "OnUs"
export const MdrOffUs = "OffUs"
export const InsertDateFormat = "yyyy-MM-DD"
export const ViewDateFormat = "DD MMM yyyy"
export const DeployedYear = "2025"
export const PaymentTypeDeposit = "1"
export const PaymentTypeRent = "2"
export const BookingStatusActive = '1'
export const BookingStatusComplete = '2'

export const DropdownStatusList = [
    {label: "All", value: ""},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]
export const PageSizeOptions = [
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "All", value: "10000"},
]

export const DropdownMonthList = [
    {label: "January", value: "1"},
    {label: "February", value: "2"},
    {label: "March", value: "3"},
    {label: "April", value: "4"},
    {label: "May", value: "5"},
    {label: "June", value: "6"},
    {label: "July", value: "7"},
    {label: "August", value: "8"},
    {label: "September", value: "9"},
    {label: "October", value: "10"},
    {label: "November", value: "11"},
    {label: "December", value: "12"}
]
export const DropdownYearList = [
    {label: "2025", value: "2025"},
    {label: "2026", value: "2026"},
    {label: "2027", value: "2027"},
    {label: "2028", value: "2028"},
    {label: "2029", value: "2029"},
]

export const DropdownGender = [
    {label: "Male", value: "1"},
    {label: "Female", value: "2"}
]
export const DropdownBookingStatus = [
    {label: "Active", value: "1"},
    {label: "Complete", value: "2"},
    {label: "Cancelled", value: "3"}
]
export const DropdownBookingType = [
    {label: "Daily", value: "1"},
    {label: "Weekly", value: "2"},
    {label: "Monthly", value: "3"},
    {label: "Yearly", value: "4"}
]
export const DropdownPaymentType = [
    {label: "All", value: ""},
    {label: "Deposit", value: "1"},
    {label: "Rent Payment", value: "2"}
]
export const DropdownPaymentTypeOptions = [
    {label: "Deposit", value: "1"},
    {label: "Rent Payment", value: "2"}
]
export const DropdownRoomStatus = [
    {label: "Active", value: "1"},
    {label: "Disabled", value: "2"}
]
export const DropdownExpenseCategory = [
    {label: "Select Expense Category", value: ""},
    {label: "Household", value: "1"},
    {label: "Human Resource", value: "2"}
]
export const DropdownDepositStatus = [
    {label: "All", value: ""},
    {label: "On Hold", value: "0"},
    {label: "Returned", value: "1"},
    {label: "Owned", value: "2"}
]
export const DropdownVehicleOptions = [
    {label: "No Vehicle", value: ""},
    {label: "Motorcycle", value: "1"},
    {label: "Car", value: "2"}
]

export const ShortDateDefault = '01 Jan 0001'

